import React from 'react'
import { useGlobalContext } from './context'
import "./Furn.css"

// components
import Navbar from './Navbar'
import FurnContainer from './FurnContainer'
// items

export default function FurnApp() {
  const {loading} = useGlobalContext()
  if (loading) {
    return (
      <div className='loading'>
        <h1>Loading...</h1>
      </div>
    )
  }
  return (
    <div className="cart-div">
      <Navbar />
      <FurnContainer />
    </div>
  )
}

